import { render, staticRenderFns } from "./galeria_main.vue?vue&type=template&id=b3aef100&scoped=true&"
import script from "./galeria_main.vue?vue&type=script&lang=js&"
export * from "./galeria_main.vue?vue&type=script&lang=js&"
import style0 from "./galeria_main.vue?vue&type=style&index=0&id=b3aef100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aef100",
  null
  
)

export default component.exports